<template>
  <div
    class="ps-card ps-border-gray ps-relative ps-overflow-hidden ps-rounded-lg ps-bg-white ps-w-full ps-h-full ps-pointer-events-auto"
  >
    <!-- <div class="ps-decorator ps-absolute ps-rounded ps-inset-0 ps-mb-8"></div> -->
    <div
      :class="{
        'ps-is-active': isSaving && tabIsActive('ROUTE_CARD_DETAILS')
      }"
      class="ps-text-white ps-text-sm ps-absolute ps-pin-t ps-mx-auto"
    >
      <!-- <p>...Working...</p> -->
    </div>
    <div
      v-if="isReady"
      :class="{
        'ps-is-saving': isSaving && tabIsActive('ROUTE_CARD_DETAILS')
      }"
      class="ps-h-full"
    >
      <div
        @click.prevent
        class="ps-header-wrap ps-bg-white ps-rounded-t-lg ps-absolute ps-z-50 ps-top-0 ps-left-0 ps-w-full ps-h-header"
      >
        <card-header
          class="ps-px-4 ps-h-20"
          ref="cardHeader"
          :validations="$v.card"
          :label="labels.card_name"
        />

        <div
          v-if="isCreateMode"
          slot="header-right"
          class="ps-notations ps-pl-4 ps-h-10 ps-ml-0 ps-mr-0 ps-flex ps-items-center ps-justify-start"
        >
          <button-group-basic class="ps--mt-2">
            <button-notation
              type="box"
              :is-first="true"
              :is-active="core.notation === 'box'"
              @button-click="$emit('notation-change', 'box')"
            >
              <svg-icon name="annotate-square" width="18" height="auto" />
            </button-notation>
            <button-notation
              type="underline"
              :is-active="core.notation === 'underline'"
              @button-click="$emit('notation-change', 'underline')"
              ><svg-icon name="annotate-underline" width="20" height="auto"
            /></button-notation>
            <button-notation
              type="highlight"
              :is-active="core.notation === 'highlight'"
              @button-click="$emit('notation-change', 'highlight')"
              ><svg-icon name="annotate-pen" width="18" height="auto"
            /></button-notation>
            <button-notation
              type="strike-through"
              :is-active="core.notation === 'strike-through'"
              @button-click="$emit('notation-change', 'strike-through')"
              ><svg-icon name="annotate-strikethrough" width="20" height="auto"
            /></button-notation>
            <button-notation
              type="crossed-off"
              :is-active="core.notation === 'crossed-off'"
              @button-click="$emit('notation-change', 'crossed-off')"
              ><svg-icon name="annotate-cross" width="20" height="auto"
            /></button-notation>
            <button-notation
              type="null"
              :is-last="true"
              :is-active="!core.notation"
              @button-click="$emit('notation-change', null)"
              >None</button-notation
            >
          </button-group-basic>
        </div>
        <tab-group v-else slot="header-right" class="ps-h-10 ps-ml-4 ps-mr-10">
          <tab-rounded
            class="ps-text-xs ps-flex-1 ps-h-10"
            v-for="t in tabs"
            :slug="t.component"
            :label="t.label"
            :key="t.slug"
            :comments-count="comments.length"
            :pages-count="pages.length"
            :browsers-count="browsers.length"
            :active="tabIsActive(t.slug)"
            @tab-click="activateTab(t.slug)"
          />
        </tab-group>

        <div
          v-if="!isPeek"
          class="ps-h-20 ps-mr-0 ps-z-20 ps-w-10 ps-absolute ps-top-0 ps-right-0 ps-justify-end"
        >
          <button-icon
            class="ps-rounded-none"
            :size="10"
            color="gray-400"
            hover-bg-color="brand-brown-200"
            @button-click="$emit('card-cancel')"
          >
            <svg-icon
              class="ps-svg-stroke-two"
              name="x-circle"
              width="28"
              height="auto"
            />
          </button-icon>
          <button-icon
            :class="[
              {
                'ps-text-white': isMinimized
              }
            ]"
            color="gray-400"
            hover-bg-color="brand-brown-200"
            class="ps-rounded-none ps--mt-px"
            :size="10"
            @button-click="$emit('card-minimize')"
          >
            <svg-icon
              class="ps-svg-stroke-two"
              :name="isMinimized ? 'plus-circle' : 'minus-circle'"
              width="28"
              height="auto"
            />
          </button-icon>
        </div>
        <div
          v-else
          class="ps-absolute ps-h-20 ps-flex ps-items-center ps-top-0 ps-right-0 ps-overflow-visible ps-pr-4"
        >
          <user-avatar
            :user="$v.card.assigned_to_user.$model"
            class="ps-w-12 ps-h-12"
          />
        </div>
      </div>
      <div
        ref="cardBody"
        class="ps-card-body ps-bg-brand-brown-25 ps-z-10 ps-pb-24 ps-h-full ps-pt-header ps-overflow-scroll"
      >
        <div
          v-if="isDifferentPage && !isCreateMode"
          class="ps-bg-teal-100 ps-p-3 ps-text-center ps-text-white"
        >
          <p class="ps-text-sm ps-text-teal-800 ">
            <span class="ps-opacity-75">Card assigned to different page: </span>
            <a :href="picnicUrl" class="ps-font-semibold">View on Page</a>
          </p>
        </div>
        <div
          v-if="latestComment && tabIsActive('ROUTE_CARD_DETAILS')"
          class="ps-pt-6 ps-px-4 ps-mb-2"
        >
          <base-label>Latest Comment</base-label>
          <div class="mt-1 rounded-lg shadow ps-bg-gray-50">
            <item-comment
              class="max-w-sm rounded-lg shadow-xs pointer-events-auto"
              :comment="latestComment"
              :key="latestComment.id"
              :show-reply-button="true"
              @reply="activateTab('ROUTE_CARD_COMMENTS')"
            />
          </div>
        </div>
        <component
          v-for="t in tabs"
          :is="tabSection(t.component)"
          v-if="tabIsActive(t.slug)"
          :key="t.slug"
          :is-create-mode="isCreateMode"
          :validations="$v"
          :type-is-sub-task="typeIsSubTask"
          :browsers="browsers"
          :pages="pages"
          :comments="comments"
          :dot-id="dotId"
          :is-different-page="isDifferentPage"
          :picnic-url="picnicUrl"
          @meta-add="$emit('meta-add', $event)"
          @section-scroll-end="scrollToEnd"
        />
      </div>

      <div
        :class="[
          {
            'is-active': tabIsActive('ROUTE_CARD_DETAILS') || !isReady
          }
        ]"
        class="ps-transition-v ps-absolute ps-z-50 ps-left-0 ps-bottom-0 ps-w-full ps-p-4"
      >
        <div class="ps-z-10 ps-button-fade ps-absolute ps-inset-0"></div>
        <div class="ps-relative ps-flex ps-z-20">
          <button-primary
            class="ps-flex-auto ps-shadow-xl ps-text-white"
            @button-click="$emit('card-save')"
            :disabled="!canSave"
          >
            <span v-if="isCreateMode" class="ps-text-white">Create</span>
            <span v-else class="ps-text-white">Save</span>
          </button-primary>

          <button-secondary
            class="ps-w-20 ps-shadow-lg ps-ml-2"
            @button-click="$emit('card-cancel')"
            >Cancel</button-secondary
          >
        </div>
      </div>
      <div
        :class="[
          {
            'is-active': tabIsActive('ROUTE_CARD_COMMENTS') && !isSaving
          }
        ]"
        class="ps-transition-v ps-absolute ps-z-50 ps-left-0 ps-bottom-0 ps-w-full ps-p-4 ps-mb-2"
      >
        <div
          class="ps-flex ps-items-end ps-bg-brand-brown-200 ps-rounded-lg ps-overflow-hidden ps-shadow-lg"
        >
          <div class="ps-flex-auto">
            <textarea-autosize
              class="ps-pt-2 ps-w-full"
              ref="commentsText"
              v-model="$v.comment.text.$model"
              :vuelidate="$v.comment.text"
              :initial-height="46"
              @enter="$emit('comment-submit')"
              @input-focus="commentFocus = true"
              @input-blur="commentFocus = false"
            >
            </textarea-autosize>
          </div>
        </div>
      </div>

      <div
        :class="[
          {
            'is-active':
              tabIsActive(['ROUTE_CARD_FILES']) && !commentFocus & !isSaving,
            'ps-pr-20': tabIsActive('ROUTE_CARD_COMMENTS')
          }
        ]"
        class="ps-pointer-events-none ps-transition-v ps-absolute ps-z-50 ps-left-0 ps-bottom-0 ps-w-full ps-flex ps-justify-end ps-p-4"
      >
        <base-drop
          :mini="tabIsActive('ROUTE_CARD_COMMENTS')"
          :class="[
            {
              'ps-w-full ps-shadow-lg': tabIsActive('files'),
              'ps-w-12': tabIsActive('ROUTE_CARD_COMMENTS')
            }
          ]"
          class="ps-pointer-events-auto ps-h-12"
        />
      </div>

      <div
        :class="[
          {
            'is-active': tabIsActive('ROUTE_CARD_PAGES') && isDifferentPage
          }
        ]"
        class="ps-transition-v ps-absolute ps-z-50 ps-left-0 ps-bottom-0 ps-w-full ps-p-4"
      >
        <div class="ps-flex">
          <button-primary
            class="ps-flex-auto ps-shadow-lg"
            @button-click="$emit('meta-add', 'page')"
          >
            Add this Page
          </button-primary>
        </div>
      </div>

      <div
        :class="[
          {
            'is-active':
              tabIsActive('ROUTE_CARD_BROWSERS') && isDifferentBrowser
          }
        ]"
        class="ps-transition-v ps-absolute ps-z-50 ps-left-0 ps-bottom-0 ps-w-full ps-p-4"
      >
        <div class="ps-flex">
          <button-primary
            class="ps-flex-auto ps-shadow-lg"
            @button-click="$emit('meta-add', 'browser')"
          >
            <loading-spinner v-if="isSaving" :size="3" bg-color="white" />
            <span v-else>Add this browser</span>
          </button-primary>
        </div>
      </div>
    </div>
    <div v-else class="ps-h-full ps-flex ps-items-start ps-justify-center">
      <div v-if="isError">
        <h3>Uh Oh. Something failed</h3>
        <button-primary
          bg-color="gray-400"
          class="ps-w-20 ps-mt-6 ps-mx-auto"
          @button-click="$emit('card-cancel')"
          >Close</button-primary
        >
      </div>
      <div class="ps-w-full" v-else>
        <div class="ps-w-full ps-bg-white h-20 ps-flex ps-items-center ps-px-4">
          <loading-spinner text-align="left" />
        </div>
        <div class="ps-h-10 ps-bg-white"></div>
        <!-- <button-primary
          bg-color="brand-brown-100"
          class="ps-w-20 ps-mt-6 ps-mx-auto"
          @button-click="$emit('card-cancel')"
          >Cancel</button-primary
        > -->
      </div>
    </div>
    <div class="ps-saving ps-absolute ps-inset-0 bg-orange" v-if="isSaving">
      ..SAVING...
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from '@picnic-software/vuex'
import BaseFormData from '@/components/forms/BaseFormData'
import BaseFormField from '@/components/forms/BaseFormField'
import BaseDrop from '@/components/inputs/BaseDrop'
import BaseLabel from '@/components/forms/BaseLabel'
import ButtonIcon from '@/components/buttons/ButtonIcon'
import ButtonPrimary from '@/components/buttons/ButtonPrimary'
import ButtonSecondary from '@/components/buttons/ButtonSecondary'
import ButtonPill from '@/components/buttons/ButtonPill'
import ButtonGroupBasic from '@/components/buttons/ButtonGroupBasic'
import TabGroup from '@/components/TabGroup'
import TabRounded from '@/components/TabRounded'
import CardHeader from '@/components/card/CardHeader'
import CardSectionDetails from '@/components/card/CardSectionDetails'
import CardSectionFiles from '@/components/card/CardSectionFiles'
import CardSectionComments from '@/components/card/CardSectionComments'
import CardSectionPages from '@/components/card/CardSectionPages'
import CardSectionBrowsers from '@/components/card/CardSectionBrowsers'
import LoadingSpinner from '@/components/LoadingSpinner'
import ItemComment from '@/components/items/ItemComment'
import ButtonNotation from '@/components/buttons/ButtonNotation'
import TextareaAutosize from '@/components/inputs/TextareaAutosize'
import UserAvatar from '@/components/UserAvatar'

import {
  ROUTE_CARD,
  ROUTE_CARD_DETAILS,
  ROUTE_CARD_COMMENTS,
  ROUTE_CARD_BROWSERS,
  ROUTE_CARD_PAGES,
  ROUTE_CARD_FILES,
  ROUTE_CARD_PEEK
} from '@/common/constants'
import '@/icons/go'
import '@/icons/card-details'
import '@/icons/card-comments'
import '@/icons/card-files'
import '@/icons/card-pages'
import '@/icons/card-browsers'
import '@/icons/x-circle'
import '@/icons/minus-circle'
import '@/icons/plus-circle'
import '@/icons/annotate-cross'
import '@/icons/annotate-pen'
import '@/icons/annotate-square'
import '@/icons/annotate-strikethrough'
import '@/icons/annotate-underline'

const CARD_TABS = [
  {
    slug: ROUTE_CARD_DETAILS,
    component: 'details',
    label: 'Details',
    isCreateMode: true
  },
  {
    slug: ROUTE_CARD_COMMENTS,
    component: 'comments',
    label: 'Comments',
    isCreateMode: false
  },
  // {
  //   slug: 'files',
  //   label: 'Files',
  //   isCreateMode: true
  // },
  {
    slug: ROUTE_CARD_PAGES,
    component: 'pages',
    label: 'Pages',
    isCreateMode: false
  },
  {
    slug: ROUTE_CARD_BROWSERS,
    component: 'browsers',
    label: 'browsers',
    isCreateMode: false
  }
]

export default {
  name: 'CardCore',
  extends: BaseFormData,
  props: {
    isReady: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => {}
    },
    browsers: {
      type: Array,
      deafult: () => []
    },
    pages: {
      type: Array,
      default: () => []
    },
    comments: {
      types: Array,
      default: () => []
    },
    currentPage: {
      type: Object,
      default: () => {}
    },
    core: {
      type: Object,
      default: () => {}
    },
    activeRoute: {
      type: String,
      default: ROUTE_CARD
    },
    isMinimized: Boolean,
    isCreateMode: Boolean,
    typeIsSubTask: Boolean,
    dotId: String
  },
  components: {
    BaseFormField,
    BaseDrop,
    BaseLabel,
    ButtonPrimary,
    ButtonSecondary,
    ButtonIcon,
    ButtonPill,
    ButtonGroupBasic,
    TabGroup,
    TabRounded,
    CardHeader,
    CardSectionDetails,
    CardSectionComments,
    CardSectionFiles,
    CardSectionPages,
    CardSectionBrowsers,
    TextareaAutosize,
    LoadingSpinner,
    ItemComment,
    ButtonNotation,
    UserAvatar
  },
  data() {
    return {
      commentFocus: false
    }
  },
  computed: {
    ...mapState({
      browserId: state => state.browser.id,
      activeTab: state => state.router.active
    }),
    canSave() {
      return this.$v.card.$anyDirty
    },
    canSaveComment() {
      return this.$v.comment.$anyDirty && !this.$v.comment.$anyError
    },
    latestComment() {
      if (this.comments.length) {
        return this.comments.slice(-1)[0]
      }
    },
    tabs() {
      if (this.isCreateMode) {
        return CARD_TABS.filter(t => t.isCreateMode)
      }
      return CARD_TABS
    },
    tabActive() {
      return this.activeTab || ROUTE_CARD
    },
    picnicUrl() {
      const [page] = this.pages
      if (page) return page.picnic_url
    },
    isDifferentBrowser() {
      return !this.browsers.find(b => b.id === this.browserId)
    },
    isDifferentPage() {
      return !this.pages.find(p => p.page_id === this.currentPage.id)
    },
    isPeek() {
      return this.activeRoute === ROUTE_CARD_PEEK
    }
  },
  watch: {
    isReady(val) {
      if (val) {
        this.initialFocus()
        this.initialTab()
      }
    },
    commentText(val) {
      if (val) {
        return (this.commentReset = null)
      }
      this.commentReset = 48
    }
  },
  mounted() {
    this.initialTab()
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to'
    }),
    initialTab() {
      if (this.activeRoute !== ROUTE_CARD) {
        this.activateTab(this.activeRoute)
      }
    },
    async initialFocus() {
      await this.$nextTick
      if (this.tabIsActive('details')) return this.focusCardName()
      if (this.tabIsActive('comments')) return this.focusCommentText()
    },
    focusCardName() {
      if (this.$refs.cardHeader) console.log(this.$refs.cardHeader)
      return this.$refs.cardHeader.$el.children[0].focus()
    },
    focusCommentText() {
      if (this.$refs.commentsText) {
        // this.$refs.commentsText.$el.focus()
      }
    },
    async activateTab(slug) {
      this.routerTo(slug)
      if (this.tabIsActive(ROUTE_CARD_COMMENTS)) {
        await this.$nextTick()
        this.focusCommentText()
      }
    },
    tabIsActive(slug) {
      if (slug.constructor === Array) {
        return slug.includes(this.tabActive)
      }
      return this.tabActive === slug
    },
    tabSection(slug) {
      return `card-section-${slug}`
    },
    scrollToEnd() {
      if (this.$refs.cardBody) {
        this.$refs.cardBody.scrollTop = this.$refs.cardBody.scrollHeight
        console.log(
          this.$refs.cardBody.scrollTop,
          this.$refs.cardBody.scrollHeight
        )
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-decorator {
  /* box-shadow: 0 0 0 12px rgba(66, 153, 225, 0.5),
    0 25px 50px -12px rgba(0, 0, 0, 0.25) !important; */
  box-shadow: 0 0 0 6px rgba(255, 111, 89, 0.8),
    0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028),
    0 12.5px 10px rgba(0, 0, 0, 0.035), 0 22.3px 17.9px rgba(0, 0, 0, 0.042),
    0 41.8px 33.4px rgba(0, 0, 0, 0.05), 0 100px 80px rgba(0, 0, 0, 0.07) !important;
}
.ps-header-wrap {
  /* background: linear-gradient(
    0deg,
    rgba(221, 91, 71, 1) 0%,
    rgba(255, 111, 89, 1) 100%
  ) !important; */
}
.ps-preview {
  transition: opacity 400ms ease;
}
.ps-card-body {
  /* height: 550px !important; */
}
.ps-button-fade {
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 50%,
    rgba(0, 0, 0, 0) 100%
  ) !important;
}
.ps-transition-v {
  transition: transform 400ms ease;
  transform: translateY(105%);
  &.is-active {
    transform: translateY(0);
  }
}
</style>
